package dev.kotlinfest._2026.components.widgets

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.display.CalloutStyle
import com.varabyte.kobweb.silk.components.display.CalloutType
import com.varabyte.kobweb.silk.components.display.CalloutVars
import com.varabyte.kobweb.silk.components.icons.InfoIcon
import com.varabyte.kobweb.silk.components.icons.WarningIcon
import com.varabyte.kobweb.silk.style.addVariant
import dev.kotlinfest._2026.SitePalette
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px

val MarkdownNoteCalloutType = CalloutType(
    icon = { InfoIcon() },
    label = "Note",
    provideColor = { SitePalette.brand.pink },
    provideBackgroundColor = { SitePalette.brand.softPink },
)

val MarkdownWarningCalloutType = CalloutType(
    icon = { WarningIcon() },
    label = "Warning",
    provideColor = { SitePalette.brand.lime },
    provideBackgroundColor = { SitePalette.brand.softLime },
)

val MarkdownCalloutVariant = CalloutStyle.addVariant {
    base {
        Modifier
            .margin(top = 0.px, bottom = 24.px)
            .padding(topBottom = 24.px, leftRight = 32.px)
            .backgroundColor(CalloutVars.BackgroundColor.value())
            .borderRadius(20.px)
            .color(SitePalette.brand.ink)
    }

    cssRule(" > .callout-title") {
        Modifier
            .color(CalloutVars.Color.value())
            .fontWeight(700)
            .margin(bottom = 12.px)
    }

    cssRule(" > .callout-title:has(.callout-label:empty)") {
        Modifier.display(DisplayStyle.None)
    }

    cssRule(":has(> .callout-title .callout-label:empty)") {
        Modifier.padding(topBottom = 16.px, leftRight = 24.px)
    }

    cssRule(" > .callout-body") {
        Modifier.styleModifier { property("overflow-wrap", "break-word") }
    }
}
